exports.f = Object.getOwnPropertySymbols;


//////////////////
// WEBPACK FOOTER
// ../~/core-js/modules/_object-gops.js
// module id = 97
// module chunks = 0